export function formatPrice(p: string | number): string {
  const n = typeof p === "string" ? Number(p) : p;
  if (!Number.isFinite(n)) return String(p);
  return n.toLocaleString("ru-RU");
}

/** Xom raqamni mingliklar ajratgich bilan ko'rsatadi ("250 000"). */
export function groupDigits(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  return Number(digits).toLocaleString("ru-RU");
}

/** Bugungi sana YYYY-MM-DD (mahalliy). */
export function todayIso(): string {
  return new Date().toLocaleDateString("en-CA");
}

/**
 * Insonparvar nisbiy sana: "Bugun", "Kecha" yoki "12 Okt".
 */
const MONTHS_UZ = [
  "Yan", "Fev", "Mar", "Apr", "May", "Iyn",
  "Iyl", "Avg", "Sen", "Okt", "Noy", "Dek",
];

export function relativeDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const now = new Date();
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  const diffDays = Math.round(
    (startOf(now).getTime() - startOf(d).getTime()) / 86400000,
  );
  if (diffDays === 0) return "Bugun";
  if (diffDays === 1) return "Kecha";
  if (diffDays === -1) return "Ertaga";
  return `${d.getDate()} ${MONTHS_UZ[d.getMonth()]}`;
}

/** Muddatgacha qolgan kunlarni inson tilida: "5 kun qoldi", "3 kun o'tdi". */
export function untilLabel(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  const diffDays = Math.round(
    (startOf(d).getTime() - startOf(now).getTime()) / 86400000,
  );
  if (diffDays === 0) return "Bugun";
  if (diffDays > 0) {
    if (diffDays >= 60) return `${Math.round(diffDays / 30)} oydan so'ng`;
    return `${diffDays} kun qoldi`;
  }
  return `${Math.abs(diffDays)} kun o'tdi`;
}
